var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.devices),function(device){return _c('div',{key:device.hash,class:[
            'col-xs-12 mb-3',
            ("col-md-" + (_vm.devices.length <= 1 ? 12 : 6))
        ]},[_c('ca-device',{attrs:{"device":device,"fields":_vm.fields,"legend":false}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }